<h1 class="fw-700 fs-xxl text-left">
  <i class="fal fa-phone-alt mr-2"></i>
  Xác minh số điện thoại
</h1>

<p class="text-left">
  Hãy nhập và thực hiện xác minh số điện thoại (vd <b>0987654321</b>) để thuận tiện cho việc sử dụng và khôi phục tài khoản sau này. Chúng tôi
  sẽ gửi mã xác minh đến số điện thoại bạn đã nhập bên dưới. <br>
  Nếu không xác minh địa chỉ của mình, bạn sẽ không thể truy cập tiếp.
</p>

<form class="mt-5" *transloco="let translated">
  <!-- DISPLAY ERROR MESSAGE -->
  @if(this.displayErrorMessage) {
  <div class="alert alert-danger" role="alert">
    {{ this.displayErrorMessage }}
  </div>
  }

  <div class="form-group" [formGroup]="phoneForm">
    <label class="form-label" Ifor="input-email-address">Nhập số điện thoại: <span class="text-danger">
        (*)</span></label>

    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text disabled">+84</span>
      </div>
      <input id="input-email-address" class="form-control form-control-lg" placeholder="Nhập số điện thoại" type="phone"
        formControlName="phoneNumber" (keydown.enter)="onVerify()" [class.is-invalid]="
        phoneForm.invalid && (phoneForm.dirty || phoneForm.touched)
      " />
      <div class="invalid-feedback" *ngIf="phoneForm.invalid && (phoneForm.dirty || phoneForm.touched)">
        Vui lòng nhập số điện thoại đúng định dạng ví dụ: 0987654321
      </div>
    </div>

  </div>
</form>

<button type="button" [disabled]="this.phoneForm.invalid || this.showLoading" (click)="onVerify()"
  class="btn-block btn btn-lg btn-primary px-5 waves-effect waves-themed mt-4">
  @if (this.showLoading) {
  <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
  }
  <span> Gửi mã xác minh </span>
</button>
<div class="d-flex align-items-center justify-content-center cursor-pointer">
  <a (click)="this.goBack()" class="fs-xl mt-4">
    <i class="fal fa-long-arrow-left mr-2"></i>
    <span> Quay về đăng nhập </span>
  </a>
</div>
